module.exports = new __parcel__URL__("sanfran_banner.0a9db18c.png").toString();